import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Skeleton from "@mui/material/Skeleton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { ExpectedDelivery } from "../../../shared/types";
import { Button } from "@mui/material";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import { useNavigate } from "react-router";

type ExpectedDeliveriesTableProps = {
    expectedDeliveries: ExpectedDelivery[];
    loading: boolean;
};

export default function ExpectedDeliveriesTable({
    expectedDeliveries,
    loading,
}: ExpectedDeliveriesTableProps) {
    const navigate = useNavigate();

    return (
        <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Expected Deliveries
                </Typography>
                {loading ? (
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Delivery Date</TableCell>
                                <TableCell>Supplier</TableCell>
                                <TableCell>PO Number</TableCell>
                                <TableCell align="center">Lines</TableCell>
                                <TableCell align="center">Pallets</TableCell>
                                <TableCell>Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array.from({ length: 3 }).map((_, i) => (
                                <TableRow key={i}>
                                    <TableCell><Skeleton variant="text" /></TableCell>
                                    <TableCell><Skeleton variant="text" /></TableCell>
                                    <TableCell><Skeleton variant="text" /></TableCell>
                                    <TableCell align="center"><Skeleton variant="text" /></TableCell>
                                    <TableCell align="center"><Skeleton variant="text" /></TableCell>
                                    <TableCell><Skeleton variant="text" /></TableCell>
                                    <TableCell><Skeleton variant="text" /></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                ) : (
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Delivery Date</TableCell>
                                <TableCell>Supplier</TableCell>
                                <TableCell>PO Number</TableCell>
                                <TableCell align="center">Lines</TableCell>
                                <TableCell align="center">Pallets</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {expectedDeliveries.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={6}>
                                        <Typography variant="body2" color="text.secondary" sx={{ py: 3, textAlign: "center" }}>
                                            No expected deliveries for the selected date.
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ) : expectedDeliveries.map((delivery) => (
                                <TableRow key={`${delivery.po_number}-${delivery.email}`}>
                                    <TableCell>{delivery.delivery_date ? delivery.delivery_date.toLocaleDateString() : "-"}</TableCell>
                                    <TableCell>{delivery.supplier?.name || "-"}</TableCell>
                                    <TableCell>{delivery.po_number || "-"}</TableCell>
                                    <TableCell align="center">{delivery.lines.length}</TableCell>
                                    <TableCell align="center">{delivery.pallet_qty}</TableCell>
                                    <TableCell>{delivery.completed_at ? "Completed" : "Pending"}</TableCell>
                                    <TableCell align="right">
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            endIcon={<VisibilityRoundedIcon fontSize="small" />}
                                            onClick={() => navigate(`/goods-in/expected-deliveries/${delivery.id}`)}
                                        >
                                            View
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                )}
            </CardContent>
        </Card>
    );
}
